/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MonitorState } from './monitorState';
import { ActionPerformer } from './actionPerformer';


export interface Monitor { 
    creation_attempted_by?: ActionPerformer;
    /**
     * Timestamp in UTC when the creation of the monitor was attempted.
     */
    creation_attempted_ts?: Date;
    deployment_id?: string;
    /**
     * Monitor ID at the external tool (ASM).
     */
    external_monitor_id?: string;
    id?: string;
    /**
     * Timestamp in UTC when the monitor was updated.
     */
    last_updated_ts?: Date;
    monitor_name?: string;
    state?: MonitorState;
    /**
     * Version of the monitor specification.
     */
    version?: string;
}
export namespace Monitor {
}


